var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVacation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7247 1.27529C50.4544 3.00498 50.4544 5.79009 48.7247 7.49047L37.3204 18.8948L43.5356 45.837L39.4019 50L28.027 28.2175L16.5934 39.6511L17.6488 46.8924L14.5119 50L9.3521 40.6772L0 35.4881L3.10759 32.3219L10.4368 33.4066L21.7825 22.061L0 10.5981L4.163 6.46438L31.1053 12.6796L42.5095 1.27529C44.1513 -0.425095 47.083 -0.425095 48.7247 1.27529Z",
    fill: "#4CBDC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVacation);
export default __webpack_public_path__ + "static/media/ic_vacation.b6dae30e3db41a822409b7039188f782.svg";
export { ForwardRef as ReactComponent };